import React from "react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
const stats = [{
  value: "6",
  label: "Specialized Blueprints"
}, {
  value: "30+",
  label: "Planned Review Tools and Worksheets"
}, {
  value: "5",
  label: "Exclusive Bonus Resources"
}];
export function IntroSection() {
  return <section className="bg-paper px-4 py-16 sm:py-24" data-id="element-224" data-mp="v31jv6ogbwsl">
      <div className="mx-auto max-w-5xl" data-id="element-225" data-mp="q487jhkwibu0">
        <SectionHeading tone="light" kicker="A more structured way to review every case" title="What if you could approach your next ClinCheck with a clear process?" intro={<>
              <p data-id="element-227" data-mp="h9sbn9c8phbn">Instead of relying on memory alone, that's exactly why I created The ClinCheck Blueprint.</p>
              <p className="mt-4" data-id="element-228" data-mp="7dz1fwlztzx1">
                I brought the most important stages of clinical review into one organized system — so you know what to
                evaluate, what questions to ask, and which concerns may require further investigation.
              </p>
            </>} data-id="element-226" data-mp="q61dsvrlqu1h" />

        <div className="mt-10 overflow-hidden rounded-3xl bg-navy text-white" data-id="element-229" data-mp="1nllkb7rpthrs">
          <div className="border-b border-white/10 p-6 text-center sm:p-8" data-id="element-230" data-mp="1nnoem3zwhx2b">
            <p className="text-sm font-bold uppercase text-brand" data-id="element-231" data-mp="18ysauj4vn67i">Your clinical review, organized</p>
            <p className="mt-2 font-display text-6xl font-extrabold text-white sm:text-7xl" data-id="element-232" data-mp="1dwbslt0sa147">10 min</p>
            <p className="mt-1 text-lg font-semibold text-white/80" data-id="element-233" data-mp="21jjt7xn9olzw">Target review time for eligible cases</p>
          </div>
          <div className="grid grid-cols-3 divide-x divide-white/10" data-id="element-234" data-mp="1rngt0xbz6xfl">
            {stats.map(s => <div key={s.label} className="px-2 py-5 text-center sm:px-6" data-id="element-235" data-mp="1wm9vlupq540z">
                <p className="font-display text-3xl font-extrabold text-brand sm:text-4xl" data-id="element-236" data-mp="1wocwj9sf0hkh">{s.value}</p>
                <p className="mt-1 text-xs font-medium leading-snug text-white/75 sm:text-sm" data-id="element-237" data-mp="gamppv9wvf75">{s.label}</p>
              </div>)}
          </div>
        </div>

        <p className="mx-auto mt-4 max-w-2xl text-center text-xs leading-relaxed text-navy/60" data-id="element-238" data-mp="2ntik1aztuw19">
          The 10-minute target is a proposed workflow goal, not a guarantee. Actual review time depends on case complexity,
          available records, and the clinical questions requiring further assessment.
        </p>

        <div className="mt-10" data-id="element-239" data-mp="2931gnm3mtw1q">
          <CTAButton label="I want a clear review process" data-id="element-240" data-mp="246khlwuw9x9v" />
        </div>
      </div>
    </section>;
}